var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33366 1.33203C9.70185 1.33203 10.0003 1.63051 10.0003 1.9987V4.66536H12.667C13.0352 4.66536 13.3337 4.96384 13.3337 5.33203C13.3337 5.70022 13.0352 5.9987 12.667 5.9987H10.0003C9.6467 5.9987 9.30756 5.85822 9.05752 5.60817C8.80747 5.35813 8.66699 5.01899 8.66699 4.66536V1.9987C8.66699 1.63051 8.96547 1.33203 9.33366 1.33203Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66699 2.66536C4.49018 2.66536 4.32061 2.7356 4.19559 2.86063C4.07056 2.98565 4.00033 3.15522 4.00033 3.33203V12.6654C4.00033 12.8422 4.07056 13.0117 4.19559 13.1368C4.32061 13.2618 4.49018 13.332 4.66699 13.332H11.3337C11.5105 13.332 11.68 13.2618 11.8051 13.1368C11.9301 13.0117 12.0003 12.8422 12.0003 12.6654V5.60817L9.05752 2.66536H4.66699ZM3.25278 1.91782C3.62785 1.54274 4.13656 1.33203 4.66699 1.33203H9.33366C9.51047 1.33203 9.68004 1.40227 9.80506 1.52729L13.1384 4.86063C13.2634 4.98565 13.3337 5.15522 13.3337 5.33203V12.6654C13.3337 13.1958 13.1229 13.7045 12.7479 14.0796C12.3728 14.4546 11.8641 14.6654 11.3337 14.6654H4.66699C4.13656 14.6654 3.62785 14.4546 3.25278 14.0796C2.87771 13.7045 2.66699 13.1958 2.66699 12.6654V3.33203C2.66699 2.8016 2.87771 2.29289 3.25278 1.91782Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.7be851d89745a2d9b0b6bfeb6dece6fc.svg";
export { ForwardRef as ReactComponent };